module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-Medium-4e2723bfec21fee1c68fc9b0e571f9d1.ttf";